
























// This component is typically used as a dynamic component inside ModalWrapperComponent

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '../TokenUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';
import GoogleLoginButtonComponent from '@/components/GoogleLoginButtonComponent.vue';                       // @ is an alias to /src

@Component({
  name: 'RegisterFormComponent',
  components: { GoogleLoginButtonComponent } 
})
export default class RegisterFormComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public preFilledUser: TokenUser
  public REQUIRE_PASSWORD2 = true
  public REQUIRE_USERNAME = false
  public email: string = null;
  public password: string = null;
  public password2: string = null;
  public username: string = null;

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  public clearFields() {
    this.email = null;
    this.password = null;
    this.password2 = null;
  }
  public onCancel() {
    this.$emit('close', false)
    this.clearFields()
  }

  // Parents call this to show modal (use a ref to call child -- https://stackoverflow.com/questions/42632711/how-to-call-function-on-child-component-on-parent-events)
  public async onShow(dynamicProps: { preFilledUser: TokenUser, email?: string  }) {
    if (!dynamicProps) return
    if (dynamicProps.preFilledUser) {
      this.preFilledUser = dynamicProps.preFilledUser

      this.email = dynamicProps.preFilledUser.email          // probably the only one guaranteed to be filled in, depending on our UI requirements at invite stage
    }
    if (dynamicProps.email) {
      this.email = dynamicProps.email;
    }
  }

  public async onOK() {
    // tidy up form fields
    if (this.email) this.email = this.email.trim()
    if (this.password) this.password = this.password.trim()
    if (this.password2) this.password2 = this.password2.trim()

    // validate form fields
    let abort: boolean = false
    if (!this.email || this.email.length === 0) {
      abort = true
      utils.toast(this, 'Missing field', 'Please enter an email address.')
    }
    if (this.email && !utils.isValidEmail(this.email)) {
      abort = true
      utils.toast(this, 'Invalid email', 'Please enter a valid email address.')
    }
    if (!this.password || this.password.length === 0) {
      abort = true
      utils.toast(this, 'Missing field', 'Please create a password.')
    } else if (!utils.isValidPassword(this.password)) {
      abort = true
      utils.toast(this, 'Invalid password', 'Your password must be at least 4 characters.')
    }
    if (this.REQUIRE_PASSWORD2) {
      if (!this.password2 || this.password2.length === 0) {
        abort = true
        utils.toast(this, 'Missing field', 'Password is required twice.')
      }
      if (this.password !== this.password2) {
        abort = true
        utils.toast(this, 'Invalid passwords', 'Passwords must match.')
      }
    }
    if (this.REQUIRE_USERNAME) {
      if (!this.username || this.username.length === 0) {
        abort = true
        utils.toast(this, 'Missing field', 'Please enter your Top Shot username.')
      }
    }

    if (abort) return

    // get utm parameters in case we have them captured by App, Home, HomeAnonymous, Blog or Lander.vue
    const utm_source: string = localStorage.getItem('utm_source')
    const utm_campaign: string = localStorage.getItem('utm_campaign')
    const utm_medium: string = localStorage.getItem('utm_medium')
    const utm_content: string = localStorage.getItem('utm_content')
    const utm_term: string = localStorage.getItem('utm_term')

    // make POST call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/auth/register'

      const response: any = await utils.makePostCall(url, { email: this.email, password: this.password, password2: this.password2, username: this.username, utm_source, utm_campaign, utm_medium, utm_content, utm_term } );
      if (!response || !response.data) throw(new Error('RegisterFormComponent.onOK() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
        // TODO: if error is "A user with that email already exists." then encourgage forgotton password flow
      }
      if (response.data.user) {
        // success
        this.$emit('close', true)

        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)

        utils.toast(this, 'Success', `You are registered on LiveToken as ${this.email}.`)

        utils_tracker.alias(user)  // tie the previously anon user to this newly id'd user

        utils_tracker.track('User Registered', { email: this.email })

        // go to homepage - wrap in try/catch to avoid NavigationDuplicated error
        try { await this.$router.push({ name: 'home' }) } catch (Error) {}

        // clear out in case they do another
        this.clearFields()
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not register')
      if (this.$store.state.devmode) console.error(error);
    }

    this.$store.commit('setLoading', { loading: false });

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    utils_tracker.track('User ClickedSignup', {})

  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
